import React from "react";
import DocumentViewerNative from "components/DocumentViewer/DocumentViewerNative";

const PrivacyPolicyNativePage: React.FC = () => {
    return (
        <DocumentViewerNative
            titleKey="pages.login.privacyPolicy"
            documentType="privacy"
        />
    );
};

export default PrivacyPolicyNativePage;
